// import DatePicker from 'react-datepicker';
// import { Grid, TextField } from '@mui/material';
// import { getMonth, getYear } from 'date-fns';
// import { range } from 'lodash';
// import { useMaterialUIController } from 'context';

// function PickDate({ ...props }) {
//   const [controller] = useMaterialUIController();
//   const { darkMode } = controller;
//   const years = range(2000, getYear(new Date()) + 1, 1);
//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   return (
//     <DatePicker
//       className={darkMode ? 'datePickerValue' : 'datePickerValueWhite'}
//       dateFormat="MMM d, yyyy"
//       maxDate={props.maxDate}
//       minDate={props.minDate}
//       disabled={props.disabled}
//       shouldCloseOnSelect={true}
//       isClearable={false}
//       customInput={
//         <TextField
//           label={props.label}
//           variant="outlined"
//           fullWidth
//         />
//       }
//       renderCustomHeader={({
//         date,
//         changeYear,
//         changeMonth,
//       }) => (
//         <Grid
//           style={{
//             margin: 10,
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <select
//             style={{ width: '50%' }}
//             value={getYear(date)}
//             onChange={({ target: { value } }) => {
//               console.log("Year selected:", parseInt(value, 10));
//               changeYear(parseInt(value, 10));
//             }}
//             onBlur={({ target: { value } }) => {
//               console.log("Year blurred:", parseInt(value, 10));
//               changeYear(parseInt(value, 10));
//             }}
//           >
//             {years.map((option) => (
//               <option key={option} value={option}>
//                 {option}
//               </option>
//             ))}
//           </select>
//           <div style={{ width: '5%' }}></div>
//           <select
//             style={{ width: '50%' }}
//             value={months[getMonth(date)]}
//             onChange={({ target: { value } }) => {
//               console.log("Month selected:", value);
//               changeMonth(months.indexOf(value));
//             }}
//             onBlur={({ target: { value } }) => {
//               console.log("Month blurred:", value);
//               changeMonth(months.indexOf(value));
//             }}
//           >
//             {months.map((option) => (
//               <option key={option} value={option}>
//                 {option}
//               </option>
//             ))}
//           </select>
//         </Grid>
//       )}
//       selected={props.selected}
//       onChange={props.onChange}
//     />
//   );
// }

// export default PickDate;

import DatePicker from 'react-datepicker';
import { TextField } from '@mui/material';
import { useEffect } from 'react';
import { useMaterialUIController } from 'context';
import { getColorMappings } from "components/ColorComponent/ColorComponent";

function PickDate({ ...props }) {
  // const [controller] = useMaterialUIController();
  // const { darkMode, tableBorder } = controller;
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;

  const { tableBorder } = getColorMappings(sidenavColor);
  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    for (let i = 0; i < element.length; i++) {

        element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
        labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }
}, [darkMode])

  return (
    <DatePicker
      className={darkMode ? 'datePickerValue' : 'datePickerValueWhite'}
      dateFormat="MMM d, yyyy"
      maxDate={props.maxDate}
      minDate={props.minDate}
      disabled={props.disabled}
      shouldCloseOnSelect={true}
      isClearable={false}
      customInput={
        <TextField
          label={props.label}
          variant="outlined"
          fullWidth

        />
      }
      selected={props.selected}
      onChange={props.onChange}
    />
  );
}

export default PickDate;
